// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KJv9","clinicsSelect":"styles_clinicsSelect__2k44y"};